export default __webpack_public_path__ + "static/media/313.89094a17.png";